<tec-modal
    [isVisible]="true"
    [title]="detail ? ('COMPANIES.FORM.EDIT' | translate) : ('COMPANIES.FORM.CREATE' | translate)"
    [tagImage]="{ icon: 'icon-briefcase' }"
    [buttonPrimaryLabel]="buttonPrimaryLabel"
    [buttonSecondaryLabel]="buttonSecondaryLabel"
    (closeEvent)="closeModal($event)"
>
    <ng-container body [formGroup]="form">
        @if (errorMsg) {
            <tec-alert status="error" [msg]="errorMsg" (closeAlert)="errorMsg = ''" />
        }

        @if (isCreateMode) {
            <tec-stepper-micro [steps]="steps" (clickEvent)="clickStep($event)" />
        }

        <!-- Crear paso 1 (Figma 10941:92619): campos 2 por fila + Configuración avanzada cerrada -->
        @if (isCreateMode && currentStep() === 'info') {
            <tec-tile [subtitle]="'COMPANIES.FORM.INFO_DESCRIPTION' | translate">
                <div class="grid grid-i2">
                    <tec-form-group
                        [label]="('COMPANIES.FORM.NAME' | translate) + '*'"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('name'))"
                    >
                        <tec-input formControlName="name" [hasError]="reactiveFormService.hasError(form.get('name'))" />
                    </tec-form-group>
                    <tec-form-group
                        [label]="('COMPANIES.FORM.CODE' | translate) + '*'"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('code'))"
                    >
                        <tec-input formControlName="code" [hasError]="reactiveFormService.hasError(form.get('code'))" />
                    </tec-form-group>
                    <tec-form-group
                        [label]="'COMPANIES.FORM.COUNTRY' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('country'))"
                    >
                        <tec-select
                            allowDeselect
                            formControlName="country"
                            [options]="allCountries"
                            [placeholder]="'COMPANIES.FORM.COUNTRY_PLACEHOLDER' | translate"
                            [hasError]="reactiveFormService.hasError(form.get('country'))"
                        />
                    </tec-form-group>
                    <tec-form-group
                        [label]="'COMPANIES.FORM.DEFAULT_WORKFLOW' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('profile_uuids'))"
                    >
                        <tec-select
                            multiple
                            formControlName="profile_uuids"
                            [placeholder]="'PROCESSES.CREATE_MODAL.WORKFLOW_PLACEHOLDER' | translate"
                            [options]="masterService.defaultProfiles"
                            [hasError]="reactiveFormService.hasError(form.get('profile_uuids'))"
                        />
                    </tec-form-group>
                </div>

                <tec-item
                    [title]="'COMPANIES.FORM.ADVANCED_SETTINGS' | translate"
                    collapse
                    [expanded]="false"
                >
                    <div class="item-group">
                        <tec-item
                            [classes]="['item--outline']"
                            [title]="'COMPANIES.FORM.DESIGN' | translate"
                            [tagImage]="{ icon: 'icon-customize' }"
                        >
                            <tec-list-detail>
                                <span>{{ 'COMPANIES.FORM.DESIGN_DESCRIPTION' | translate }}</span>
                            </tec-list-detail>
                            <tec-switch formControlName="default_design_config" />
                        </tec-item>
                        <tec-item
                            [classes]="['item--outline']"
                            [title]="'COMPANIES.FORM.APIKEY' | translate"
                            [tagImage]="{ icon: 'icon-lock' }"
                        >
                            <tec-list-detail>
                                <span>{{ 'COMPANIES.FORM.APIKEY_DESCRIPTION' | translate }}</span>
                            </tec-list-detail>
                            <tec-switch formControlName="default_api_key" />
                        </tec-item>
                    </div>
                </tec-item>
            </tec-tile>
        }

        <!-- Crear paso 2 (Figma 10941:93410): reglas operativas; Cancelar encima de Atrás/Guardar -->
        @if (isCreateMode && currentStep() === 'config') {
            <tec-tile [subtitle]="'COMPANIES.FORM.SETTINGS_DESCRIPTION' | translate">
                <div class="item-group">
                    <tec-item
                        [classes]="['item--outline']"
                        [title]="'COMPANIES.FORM.MANUAL_VALIDATION' | translate"
                        [tagImage]="{ icon: 'icon-check-circle' }"
                    >
                        <tec-list-detail>
                            <span>{{ 'COMPANIES.FORM.MANUAL_VALIDATION_DESCRIPTION' | translate }}</span>
                        </tec-list-detail>
                        <tec-switch formControlName="manual_validation" />
                    </tec-item>

                    <tec-divider />

                    <tec-item
                        [title]="'COMPANIES.FORM.DOCUMENT_RETENTION_DAYS' | translate"
                        [tagImage]="{ icon: 'icon-file' }"
                        [outline]="true"
                    >
                        <tec-list-detail>
                            <span>{{ 'COMPANIES.FORM.RETENTION_STORAGE_DESCRIPTION' | translate }}</span>
                        </tec-list-detail>
                        <tec-form-group>
                            <app-retention-duration-input
                                formControlName="document_retention_days"
                                [hasError]="retentionHasError(form.get('document_retention_days'))"
                            />
                        </tec-form-group>
                    </tec-item>

                    <tec-divider />

                    <tec-item
                        [title]="'COMPANIES.FORM.MEDIA_RETENTION_DAYS' | translate"
                        [tagImage]="{ icon: 'icon-image' }"
                        [outline]="true"
                    >
                        <tec-list-detail>
                            <span>{{ 'COMPANIES.FORM.RETENTION_STORAGE_DESCRIPTION' | translate }}</span>
                        </tec-list-detail>
                        <tec-form-group>
                            <app-retention-duration-input
                                formControlName="media_retention_days"
                                [hasError]="retentionHasError(form.get('media_retention_days'))"
                            />
                        </tec-form-group>
                    </tec-item>

                    <tec-divider />

                    <tec-item
                        [title]="'COMPANIES.FORM.INFO_RETENTION_DAYS' | translate"
                        [tagImage]="{ icon: 'icon-text' }"
                        [outline]="true"
                    >
                        <tec-list-detail>
                            <span>{{ 'COMPANIES.FORM.RETENTION_STORAGE_DESCRIPTION' | translate }}</span>
                        </tec-list-detail>
                        <tec-form-group>
                            <app-retention-duration-input
                                formControlName="info_retention_days"
                                [hasError]="retentionHasError(form.get('info_retention_days'))"
                            />
                        </tec-form-group>
                    </tec-item>
                </div>
            </tec-tile>

            <div class="companies-form__cancel">
                <tec-link [label]="'BUTTON.CANCEL' | translate" (click)="cancelCreate($event)" />
            </div>
        }

        <!-- Edición (Figma 5942:123730): Información + settings visibles; Cancelar + Guardar -->
        @if (!isCreateMode) {
            <tec-tile [title]="'COMPANIES.FORM.INFO' | translate" icon="icon-briefcase">
                <div class="grid grid-i2">
                    <tec-form-group
                        [label]="('COMPANIES.FORM.NAME' | translate) + '*'"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('name'))"
                    >
                        <tec-input formControlName="name" [hasError]="reactiveFormService.hasError(form.get('name'))" />
                    </tec-form-group>
                    <tec-form-group
                        [label]="('COMPANIES.FORM.CODE' | translate) + '*'"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('code'))"
                    >
                        <tec-input formControlName="code" [hasError]="reactiveFormService.hasError(form.get('code'))" />
                    </tec-form-group>
                    <tec-form-group
                        [label]="'COMPANIES.FORM.COUNTRY' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('country'))"
                    >
                        <tec-select
                            allowDeselect
                            formControlName="country"
                            [options]="allCountries"
                            [placeholder]="'COMPANIES.FORM.COUNTRY_PLACEHOLDER' | translate"
                            [hasError]="reactiveFormService.hasError(form.get('country'))"
                        />
                    </tec-form-group>
                </div>
            </tec-tile>

            <tec-tile styling="thin">
                <div class="item-group">
                    <tec-item
                        [classes]="['item--outline']"
                        [title]="'COMPANIES.FORM.MANUAL_VALIDATION' | translate"
                        [tagImage]="{ icon: 'icon-check-circle' }"
                    >
                        <tec-list-detail>
                            <span>{{ 'COMPANIES.FORM.MANUAL_VALIDATION_DESCRIPTION' | translate }}</span>
                        </tec-list-detail>
                        <tec-switch formControlName="manual_validation" />
                    </tec-item>

                    <tec-divider />

                    <tec-item
                        [classes]="['item--outline']"
                        [title]="'COMPANIES.FORM.DOCUMENT_RETENTION_DAYS' | translate"
                        [tagImage]="{ icon: 'icon-file' }"
                    >
                        <tec-list-detail>
                            <span>{{ 'COMPANIES.FORM.RETENTION_STORAGE_DESCRIPTION' | translate }}</span>
                        </tec-list-detail>
                        <tec-form-group>
                            <app-retention-duration-input
                                formControlName="document_retention_days"
                                [hasError]="retentionHasError(form.get('document_retention_days'))"
                            />
                        </tec-form-group>
                    </tec-item>

                    <tec-divider />

                    <tec-item
                        [classes]="['item--outline']"
                        [title]="'COMPANIES.FORM.MEDIA_RETENTION_DAYS' | translate"
                        [tagImage]="{ icon: 'icon-image' }"
                    >
                        <tec-list-detail>
                            <span>{{ 'COMPANIES.FORM.RETENTION_STORAGE_DESCRIPTION' | translate }}</span>
                        </tec-list-detail>
                        <tec-form-group>
                            <app-retention-duration-input
                                formControlName="media_retention_days"
                                [hasError]="retentionHasError(form.get('media_retention_days'))"
                            />
                        </tec-form-group>
                    </tec-item>

                    <tec-divider />

                    <tec-item
                        [classes]="['item--outline']"
                        [title]="'COMPANIES.FORM.INFO_RETENTION_DAYS' | translate"
                        [tagImage]="{ icon: 'icon-text' }"
                    >
                        <tec-list-detail>
                            <span>{{ 'COMPANIES.FORM.RETENTION_STORAGE_DESCRIPTION' | translate }}</span>
                        </tec-list-detail>
                        <tec-form-group>
                            <app-retention-duration-input
                                formControlName="info_retention_days"
                                [hasError]="retentionHasError(form.get('info_retention_days'))"
                            />
                        </tec-form-group>
                    </tec-item>
                </div>
            </tec-tile>
        }
    </ng-container>
</tec-modal>
